// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

import SpeakerNotesOffIcon from "@mui/icons-material/SpeakerNotesOff";

import ReportIcon from "@mui/icons-material/Report";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";
// Dashboard components
import Projects from "layouts/dashboard/components/Projects";
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";
import { useCallback, useEffect, useState } from "react";
import apiClient from "Utils/apiClient";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import HealingIcon from "@mui/icons-material/Healing";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";

import SecurityIcon from "@mui/icons-material/Security";

import BusinessIcon from "@mui/icons-material/Business";
import { getCurrentAdminState } from "Utils/Functions";
import { async } from "@firebase/util";
import { useSelector } from "react-redux";

function Dashboard() {
  const { sales, tasks } = reportsLineChartData;
  const allData = useSelector((state) => state.data.allData);
  const [totalUserCount, setTotalUserCount] = useState(0);
  const [newUserCountThisMonth, setNewUserCountThisMonth] = useState(0);
  const [totalSOSCount, setTotalSOSCount] = useState(0);
  const [newSOSCountThisMonth, setNewSOSCountThisMonth] = useState(0);
  const [totalWellBeingServicesCount, setTotalWellBeingServicesCount] = useState(0);
  const [newWellBeingServicesCountThisMonth, setNewWellBeingServicesCountThisMonth] = useState(0);
  const [totalVirtualHomeCheckCount, setTotalVirtualHomeCheckCount] = useState(0);
  const [newVirtualHomeCheckCountThisMonth, setNewVirtualHomeCheckCountThisMonth] = useState(0);

  const [totalVehicles, setTotalVehicles] = useState(0);
  const [totalDrivers, setTotalDrivers] = useState(0);
  const [newVehiclesThisMonth, setNewVehiclesThisMonth] = useState(0);

  const [totalOperators, setTotalOperators] = useState(0);
  const [newOperatorsThisMonth, setNewOperatorsThisMonth] = useState(0);
  const [totalWhistleBlowers, setTotalWhistleBlowers] = useState(0);
  const [newWhistleBlowersThisMonth, setNewWhistleBlowersThisMonth] = useState(0);

  const [loading, setLoading] = useState(false);

  const fetchDashboardStats = async () => {
    try {
      setLoading(true);
      const currentAdminState = await getCurrentAdminState();
      const stateParam = allData ? 'allData' : currentAdminState;
      
      const response = await apiClient.get('/dashboard/stats', {
        params: { state: stateParam }
      });
      
      if (response && response.data) {
        setTotalUserCount(response.data.totalUserCount || 0);
        setTotalOperators(response.data.totalOperators || 0);
        setTotalWhistleBlowers(response.data.totalWhistleBlowers || 0);
        setTotalSOSCount(response.data.totalSOSCount || 0);
        setTotalWellBeingServicesCount(response.data.totalWellBeingServicesCount || 0);
        setTotalVirtualHomeCheckCount(response.data.totalVirtualHomeCheckCount || 0);
        setTotalVehicles(response.data.totalVehicles || 0);
        setTotalDrivers(response.data.totalDrivers || 0);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardStats();
  }, [allData]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={6} style={{ position: "relative", minHeight: "60vh" }}>
          {loading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center", // Ensure horizontal centering
              }}
            >
              Loading...
            </div>
          ) : (
            <>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    icon="leaderboard"
                    title="Total Users"
                    count={totalUserCount}
                    onClick="Users"
                    percentage={{
                      color: "success",
                      // amount: `${newUserCountThisMonth}`,
                      // label: "than last month",
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="dark"
                    icon={<ReportIcon style={{ marginBottom: 20 }} />}
                    title="WhistleBlower"
                    count={totalWhistleBlowers}
                    onClick="WhistleBlower"
                    percentage={{
                      color: "success",
                      // amount: `${newWhistleBlowersThisMonth}`,
                      // label: "than lask week",
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="dark"
                    icon="weekend"
                    title="SOS"
                    count={totalSOSCount}
                    onClick="Notifications"
                    percentage={{
                      color: "success",
                      // amount: `${newSOSCountThisMonth}`,
                      // label: "than lask week",
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="success"
                    icon={
                      <HealingIcon style={{ marginBottom: 30 }} fontSize="medium" color="inherit" />
                    }
                    title="Virtual Home Check"
                    count={totalVirtualHomeCheckCount}
                    onClick="VirtualHomeCheck"
                    percentage={{
                      color: "success",
                      // amount: `${totalWellBeingServicesCount}`,
                      // label: "than last month",
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="primary"
                    icon={
                      <SecurityIcon fontSize="lg" style={{ marginBottom: 30 }} color="inherit" />
                    }
                    title="Virtul Travel Guard"
                    count={totalWellBeingServicesCount}
                    onClick="WellbeingManagment"
                    percentage={{
                      color: "success",
                      // amount: `${newVirtualHomeCheckCountThisMonth}`,
                      // label: "Just updated",
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="secondary"
                    icon={
                      <DirectionsCarIcon
                        fontSize="lg"
                        style={{ marginBottom: 30 }}
                        color="inherit"
                      />
                    }
                    title="Registered Vehicle & Drivers"
                    count={`${totalVehicles} Vehicles`}
                    onClick="vehicle"
                    percentage={{
                      color: "success",
                      // amount: `${newVehiclesThisMonth}`,
                      // // label: "Just updated",
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="warning"
                    icon={
                      <BusinessIcon fontSize="lg" style={{ marginBottom: 30 }} color="inherit" />
                    }
                    title="Provider"
                    count={totalOperators}
                    onClick="AmbulamceProviders"
                    percentage={{
                      color: "success",
                      // amount: `${newOperatorsThisMonth}`,
                      // // label: "Just updated",
                    }}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <MDBox mb={1.5}>
                  <ComplexStatisticsCard
                    color="warning"
                    icon={
                      <BusinessIcon fontSize="lg" style={{ marginBottom: 30 }} color="inherit" />
                    }
                    title="Trip Monitor"
                    count={totalOperators}
                    onClick="tripMonitor"
                    percentage={{
                      color: "success",
                      // amount: `${newOperatorsThisMonth}`,
                      // // label: "Just updated",
                    }}
                  />
                </MDBox>
              </Grid>
            </>
          )}
        </Grid>

        {/* <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="info"
                  title="website views"
                  description="Last Campaign Performance"
                  date="campaign sent 2 days ago"
                  chart={reportsBarChartData}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="daily sales"
                  description={
                    <>
                      (<strong>+15%</strong>) increase in today sales.
                    </>
                  }
                  date="updated 4 min ago"
                  chart={sales}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="dark"
                  title="completed tasks"
                  description="Last Campaign Performance"
                  date="just updated"
                  chart={tasks}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox> */}
        {/* <MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={8}>
              <Projects />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <OrdersOverview />
            </Grid>
          </Grid>
        </MDBox> */}
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Dashboard;
